module.exports = __webpack_public_path__ + "img/MOTOR.7fa4bb17.svg";